var commonjsGlobal = "undefined" != typeof window ? window : "undefined" != typeof global ? global : "undefined" != typeof self ? self : {};
function createCommonjsModule(t, e) {
  return t(e = {
    exports: {}
  }, e.exports), e.exports;
}
var _sha = createCommonjsModule(function (t, e) {
    !function (e) {
      function r(t, e, r) {
        var n,
          p,
          f,
          h,
          l,
          d,
          v,
          y,
          g,
          E = 0,
          b = [],
          w = 0,
          R = !1,
          C = [],
          A = [],
          _ = !1;
        if (n = (r = r || {}).encoding || "UTF8", (g = r.numRounds || 1) !== parseInt(g, 10) || 1 > g) throw Error("numRounds must a integer >= 1");
        if (0 !== t.lastIndexOf("SHA-", 0)) throw Error("Chosen SHA variant is not supported");
        if (d = function d(e, r) {
          return S(e, r, t);
        }, v = function v(e, r, n, o) {
          var i, a;
          if ("SHA-224" !== t && "SHA-256" !== t) throw Error("Unexpected error in SHA-2 implementation");
          for (i = 15 + (r + 65 >>> 9 << 4), a = 16; e.length <= i;) e.push(0);
          for (e[r >>> 5] |= 128 << 24 - r % 32, r += n, e[i] = 4294967295 & r, e[i - 1] = r / 4294967296 | 0, n = e.length, r = 0; r < n; r += a) o = S(e.slice(r, r + a), o, t);
          if ("SHA-224" === t) e = [o[0], o[1], o[2], o[3], o[4], o[5], o[6]];else {
            if ("SHA-256" !== t) throw Error("Unexpected error in SHA-2 implementation");
            e = o;
          }
          return e;
        }, y = function y(t) {
          return t.slice();
        }, "SHA-224" === t) l = 512, h = 224;else {
          if ("SHA-256" !== t) throw Error("Chosen SHA variant is not supported");
          l = 512, h = 256;
        }
        f = c(e, n), p = m(t), this.setHMACKey = function (e, r, o) {
          var i;
          if (!0 === R) throw Error("HMAC key already set");
          if (!0 === _) throw Error("Cannot set HMAC key after calling update");
          if (e = (r = c(r, n = (o || {}).encoding || "UTF8")(e)).binLen, r = r.value, o = (i = l >>> 3) / 4 - 1, i < e / 8) {
            for (r = v(r, e, 0, m(t)); r.length <= o;) r.push(0);
            r[o] &= 4294967040;
          } else if (i > e / 8) {
            for (; r.length <= o;) r.push(0);
            r[o] &= 4294967040;
          }
          for (e = 0; e <= o; e += 1) C[e] = 909522486 ^ r[e], A[e] = 1549556828 ^ r[e];
          p = d(C, p), E = l, R = !0;
        }, this.update = function (t) {
          var e,
            r,
            n,
            o = 0,
            i = l >>> 5;
          for (t = (e = f(t, b, w)).binLen, r = e.value, e = t >>> 5, n = 0; n < e; n += i) o + l <= t && (p = d(r.slice(n, n + i), p), o += l);
          E += o, b = r.slice(o >>> 5), w = t % l, _ = !0;
        }, this.getHash = function (e, r) {
          var n, c, f, l;
          if (!0 === R) throw Error("Cannot call getHash after setting HMAC key");
          switch (f = s(r), e) {
            case "HEX":
              n = function n(t) {
                return o(t, h, f);
              };
              break;
            case "B64":
              n = function n(t) {
                return i(t, h, f);
              };
              break;
            case "BYTES":
              n = function n(t) {
                return a(t, h);
              };
              break;
            case "ARRAYBUFFER":
              try {
                c = new ArrayBuffer(0);
              } catch (t) {
                throw Error("ARRAYBUFFER not supported by this environment");
              }
              n = function n(t) {
                return u(t, h);
              };
              break;
            default:
              throw Error("format must be HEX, B64, BYTES, or ARRAYBUFFER");
          }
          for (l = v(b.slice(), w, E, y(p)), c = 1; c < g; c += 1) l = v(l, h, 0, m(t));
          return n(l);
        }, this.getHMAC = function (e, r) {
          var n, c, f, g;
          if (!1 === R) throw Error("Cannot call getHMAC without first setting HMAC key");
          switch (f = s(r), e) {
            case "HEX":
              n = function n(t) {
                return o(t, h, f);
              };
              break;
            case "B64":
              n = function n(t) {
                return i(t, h, f);
              };
              break;
            case "BYTES":
              n = function n(t) {
                return a(t, h);
              };
              break;
            case "ARRAYBUFFER":
              try {
                n = new ArrayBuffer(0);
              } catch (t) {
                throw Error("ARRAYBUFFER not supported by this environment");
              }
              n = function n(t) {
                return u(t, h);
              };
              break;
            default:
              throw Error("outputFormat must be HEX, B64, BYTES, or ARRAYBUFFER");
          }
          return c = v(b.slice(), w, E, y(p)), g = d(A, m(t)), n(g = v(c, h, l, g));
        };
      }
      function n() {}
      function o(t, e, r) {
        var n,
          o,
          i = "";
        for (e /= 8, n = 0; n < e; n += 1) o = t[n >>> 2] >>> 8 * (3 + n % 4 * -1), i += "0123456789abcdef".charAt(o >>> 4 & 15) + "0123456789abcdef".charAt(15 & o);
        return r.outputUpper ? i.toUpperCase() : i;
      }
      function i(t, e, r) {
        var n,
          o,
          i,
          a = "",
          u = e / 8;
        for (n = 0; n < u; n += 3) for (o = n + 1 < u ? t[n + 1 >>> 2] : 0, i = n + 2 < u ? t[n + 2 >>> 2] : 0, i = (t[n >>> 2] >>> 8 * (3 + n % 4 * -1) & 255) << 16 | (o >>> 8 * (3 + (n + 1) % 4 * -1) & 255) << 8 | i >>> 8 * (3 + (n + 2) % 4 * -1) & 255, o = 0; 4 > o; o += 1) a += 8 * n + 6 * o <= e ? "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".charAt(i >>> 6 * (3 - o) & 63) : r.b64Pad;
        return a;
      }
      function a(t, e) {
        var r,
          n,
          o = "",
          i = e / 8;
        for (r = 0; r < i; r += 1) n = t[r >>> 2] >>> 8 * (3 + r % 4 * -1) & 255, o += String.fromCharCode(n);
        return o;
      }
      function u(t, e) {
        var r,
          n,
          o = e / 8,
          i = new ArrayBuffer(o);
        for (n = new Uint8Array(i), r = 0; r < o; r += 1) n[r] = t[r >>> 2] >>> 8 * (3 + r % 4 * -1) & 255;
        return i;
      }
      function s(t) {
        var e = {
          outputUpper: !1,
          b64Pad: "=",
          shakeLen: -1
        };
        if (t = t || {}, e.outputUpper = t.outputUpper || !1, !0 === t.hasOwnProperty("b64Pad") && (e.b64Pad = t.b64Pad), "boolean" != typeof e.outputUpper) throw Error("Invalid outputUpper formatting option");
        if ("string" != typeof e.b64Pad) throw Error("Invalid b64Pad formatting option");
        return e;
      }
      function c(t, e) {
        var r;
        switch (e) {
          case "UTF8":
          case "UTF16BE":
          case "UTF16LE":
            break;
          default:
            throw Error("encoding must be UTF8, UTF16BE, or UTF16LE");
        }
        switch (t) {
          case "HEX":
            r = function r(t, e, _r) {
              var n,
                o,
                i,
                a,
                u,
                s = t.length;
              if (0 != s % 2) throw Error("String of HEX type must be in byte increments");
              for (e = e || [0], u = (_r = _r || 0) >>> 3, n = 0; n < s; n += 2) {
                if (o = parseInt(t.substr(n, 2), 16), isNaN(o)) throw Error("String of HEX type contains invalid characters");
                for (i = (a = (n >>> 1) + u) >>> 2; e.length <= i;) e.push(0);
                e[i] |= o << 8 * (3 + a % 4 * -1);
              }
              return {
                value: e,
                binLen: 4 * s + _r
              };
            };
            break;
          case "TEXT":
            r = function r(t, _r2, n) {
              var o,
                i,
                a,
                u,
                s,
                c,
                p,
                f,
                h = 0;
              if (_r2 = _r2 || [0], s = (n = n || 0) >>> 3, "UTF8" === e) for (f = 3, a = 0; a < t.length; a += 1) for (i = [], 128 > (o = t.charCodeAt(a)) ? i.push(o) : 2048 > o ? (i.push(192 | o >>> 6), i.push(128 | 63 & o)) : 55296 > o || 57344 <= o ? i.push(224 | o >>> 12, 128 | o >>> 6 & 63, 128 | 63 & o) : (a += 1, o = 65536 + ((1023 & o) << 10 | 1023 & t.charCodeAt(a)), i.push(240 | o >>> 18, 128 | o >>> 12 & 63, 128 | o >>> 6 & 63, 128 | 63 & o)), u = 0; u < i.length; u += 1) {
                for (c = (p = h + s) >>> 2; _r2.length <= c;) _r2.push(0);
                _r2[c] |= i[u] << 8 * (f + p % 4 * -1), h += 1;
              } else if ("UTF16BE" === e || "UTF16LE" === e) for (f = 2, i = "UTF16LE" === e || "UTF16LE" !== e && !1, a = 0; a < t.length; a += 1) {
                for (o = t.charCodeAt(a), !0 === i && (o = (u = 255 & o) << 8 | o >>> 8), c = (p = h + s) >>> 2; _r2.length <= c;) _r2.push(0);
                _r2[c] |= o << 8 * (f + p % 4 * -1), h += 2;
              }
              return {
                value: _r2,
                binLen: 8 * h + n
              };
            };
            break;
          case "B64":
            r = function r(t, e, _r3) {
              var n,
                o,
                i,
                a,
                u,
                s,
                c,
                p = 0;
              if (-1 === t.search(/^[a-zA-Z0-9=+\/]+$/)) throw Error("Invalid character in base-64 string");
              if (o = t.indexOf("="), t = t.replace(/\=/g, ""), -1 !== o && o < t.length) throw Error("Invalid '=' found in base-64 string");
              for (e = e || [0], s = (_r3 = _r3 || 0) >>> 3, o = 0; o < t.length; o += 4) {
                for (u = t.substr(o, 4), i = a = 0; i < u.length; i += 1) a |= (n = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/".indexOf(u[i])) << 18 - 6 * i;
                for (i = 0; i < u.length - 1; i += 1) {
                  for (n = (c = p + s) >>> 2; e.length <= n;) e.push(0);
                  e[n] |= (a >>> 16 - 8 * i & 255) << 8 * (3 + c % 4 * -1), p += 1;
                }
              }
              return {
                value: e,
                binLen: 8 * p + _r3
              };
            };
            break;
          case "BYTES":
            r = function r(t, e, _r4) {
              var n, o, i, a, u;
              for (e = e || [0], i = (_r4 = _r4 || 0) >>> 3, o = 0; o < t.length; o += 1) n = t.charCodeAt(o), a = (u = o + i) >>> 2, e.length <= a && e.push(0), e[a] |= n << 8 * (3 + u % 4 * -1);
              return {
                value: e,
                binLen: 8 * t.length + _r4
              };
            };
            break;
          case "ARRAYBUFFER":
            try {
              r = new ArrayBuffer(0);
            } catch (t) {
              throw Error("ARRAYBUFFER not supported by this environment");
            }
            r = function r(t, e, _r5) {
              var n, o, i, a, u;
              for (e = e || [0], o = (_r5 = _r5 || 0) >>> 3, u = new Uint8Array(t), n = 0; n < t.byteLength; n += 1) i = (a = n + o) >>> 2, e.length <= i && e.push(0), e[i] |= u[n] << 8 * (3 + a % 4 * -1);
              return {
                value: e,
                binLen: 8 * t.byteLength + _r5
              };
            };
            break;
          default:
            throw Error("format must be HEX, TEXT, B64, BYTES, or ARRAYBUFFER");
        }
        return r;
      }
      function p(t, e) {
        return t >>> e | t << 32 - e;
      }
      function f(t, e, r) {
        return t & e ^ ~t & r;
      }
      function h(t, e, r) {
        return t & e ^ t & r ^ e & r;
      }
      function l(t) {
        return p(t, 2) ^ p(t, 13) ^ p(t, 22);
      }
      function d(t) {
        return p(t, 6) ^ p(t, 11) ^ p(t, 25);
      }
      function v(t) {
        return p(t, 7) ^ p(t, 18) ^ t >>> 3;
      }
      function y(t) {
        return p(t, 17) ^ p(t, 19) ^ t >>> 10;
      }
      function g(t, e) {
        var r = (65535 & t) + (65535 & e);
        return ((t >>> 16) + (e >>> 16) + (r >>> 16) & 65535) << 16 | 65535 & r;
      }
      function E(t, e, r, n) {
        var o = (65535 & t) + (65535 & e) + (65535 & r) + (65535 & n);
        return ((t >>> 16) + (e >>> 16) + (r >>> 16) + (n >>> 16) + (o >>> 16) & 65535) << 16 | 65535 & o;
      }
      function b(t, e, r, n, o) {
        var i = (65535 & t) + (65535 & e) + (65535 & r) + (65535 & n) + (65535 & o);
        return ((t >>> 16) + (e >>> 16) + (r >>> 16) + (n >>> 16) + (o >>> 16) + (i >>> 16) & 65535) << 16 | 65535 & i;
      }
      function m(t) {
        var e,
          r = [];
        if (0 !== t.lastIndexOf("SHA-", 0)) throw Error("No SHA variants supported");
        switch (r = [3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428], e = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], t) {
          case "SHA-224":
            break;
          case "SHA-256":
            r = e;
            break;
          case "SHA-384":
          case "SHA-512":
            r = [new n(), new n(), new n(), new n(), new n(), new n(), new n(), new n()];
            break;
          default:
            throw Error("Unknown SHA variant");
        }
        return r;
      }
      function S(t, e, r) {
        var n,
          o,
          i,
          a,
          u,
          s,
          c,
          p,
          m,
          S,
          R,
          C,
          A,
          _,
          P,
          I,
          U,
          O,
          k,
          B,
          T,
          N,
          H,
          M = [];
        if ("SHA-224" !== r && "SHA-256" !== r) throw Error("Unexpected error in SHA-2 implementation");
        for (S = 64, C = 1, N = Number, A = g, _ = E, P = b, I = v, U = y, O = l, k = d, T = h, B = f, H = w, r = e[0], n = e[1], o = e[2], i = e[3], a = e[4], u = e[5], s = e[6], c = e[7], R = 0; R < S; R += 1) 16 > R ? (m = R * C, p = t.length <= m ? 0 : t[m], m = t.length <= m + 1 ? 0 : t[m + 1], M[R] = new N(p, m)) : M[R] = _(U(M[R - 2]), M[R - 7], I(M[R - 15]), M[R - 16]), p = P(c, k(a), B(a, u, s), H[R], M[R]), m = A(O(r), T(r, n, o)), c = s, s = u, u = a, a = A(i, p), i = o, o = n, n = r, r = A(p, m);
        return e[0] = A(r, e[0]), e[1] = A(n, e[1]), e[2] = A(o, e[2]), e[3] = A(i, e[3]), e[4] = A(a, e[4]), e[5] = A(u, e[5]), e[6] = A(s, e[6]), e[7] = A(c, e[7]), e;
      }
      var w;
      w = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298], t.exports && (t.exports = r), r;
    }();
  }),
  _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (t) {
    return typeof t;
  } : function (t) {
    return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t;
  },
  classCallCheck = function classCallCheck(t, e) {
    if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
  },
  createClass = function () {
    function t(t, e) {
      for (var r = 0; r < e.length; r++) {
        var n = e[r];
        n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
      }
    }
    return function (e, r, n) {
      return r && t(e.prototype, r), n && t(e, n), e;
    };
  }(),
  defineProperty = function defineProperty(t, e, r) {
    return e in t ? Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }) : t[e] = r, t;
  },
  inherits = function inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + typeof e);
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), e && (Object.setPrototypeOf ? Object.setPrototypeOf(t, e) : t.__proto__ = e);
  },
  possibleConstructorReturn = function possibleConstructorReturn(t, e) {
    if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return !e || "object" != typeof e && "function" != typeof e ? t : e;
  },
  ERROR = "input is invalid type",
  WINDOW = "object" === ("undefined" == typeof window ? "undefined" : _typeof(window)),
  root = WINDOW ? window : {};
root.JS_SHA3_NO_WINDOW && (WINDOW = !1);
var WEB_WORKER = !WINDOW && "object" === ("undefined" == typeof self ? "undefined" : _typeof(self)),
  NODE_JS = !root.JS_SHA3_NO_NODE_JS && "object" === ("undefined" == typeof process ? "undefined" : _typeof(process)) && process.versions && process.versions.node;
NODE_JS ? root = commonjsGlobal : WEB_WORKER && (root = self);
var ARRAY_BUFFER = !root.JS_SHA3_NO_ARRAY_BUFFER && "undefined" != typeof ArrayBuffer,
  HEX_CHARS = "0123456789abcdef".split(""),
  SHAKE_PADDING = [31, 7936, 2031616, 520093696],
  CSHAKE_PADDING = [4, 1024, 262144, 67108864],
  KECCAK_PADDING = [1, 256, 65536, 16777216],
  PADDING = [6, 1536, 393216, 100663296],
  SHIFT = [0, 8, 16, 24],
  RC = [1, 0, 32898, 0, 32906, 2147483648, 2147516416, 2147483648, 32907, 0, 2147483649, 0, 2147516545, 2147483648, 32777, 2147483648, 138, 0, 136, 0, 2147516425, 0, 2147483658, 0, 2147516555, 0, 139, 2147483648, 32905, 2147483648, 32771, 2147483648, 32770, 2147483648, 128, 2147483648, 32778, 0, 2147483658, 2147483648, 2147516545, 2147483648, 32896, 2147483648, 2147483649, 0, 2147516424, 2147483648],
  BITS = [224, 256, 384, 512],
  SHAKE_BITS = [128, 256],
  OUTPUT_TYPES = ["hex", "buffer", "arrayBuffer", "array", "digest"],
  CSHAKE_BYTEPAD = {
    128: 168,
    256: 136
  };
!root.JS_SHA3_NO_NODE_JS && Array.isArray || (Array.isArray = function (t) {
  return "[object Array]" === Object.prototype.toString.call(t);
}), !ARRAY_BUFFER || !root.JS_SHA3_NO_ARRAY_BUFFER_IS_VIEW && ArrayBuffer.isView || (ArrayBuffer.isView = function (t) {
  return "object" === (void 0 === t ? "undefined" : _typeof(t)) && t.buffer && t.buffer.constructor === ArrayBuffer;
});
for (var createOutputMethod = function createOutputMethod(t, e, r) {
    return function (n) {
      return new Keccak(t, e, t).update(n)[r]();
    };
  }, createShakeOutputMethod = function createShakeOutputMethod(t, e, r) {
    return function (n, o) {
      return new Keccak(t, e, o).update(n)[r]();
    };
  }, createCshakeOutputMethod = function createCshakeOutputMethod(t, e, r) {
    return function (e, n, o, i) {
      return methods["cshake" + t].update(e, n, o, i)[r]();
    };
  }, createKmacOutputMethod = function createKmacOutputMethod(t, e, r) {
    return function (e, n, o, i) {
      return methods["kmac" + t].update(e, n, o, i)[r]();
    };
  }, createOutputMethods = function createOutputMethods(t, e, r, n) {
    for (var o = 0; o < OUTPUT_TYPES.length; ++o) {
      var i = OUTPUT_TYPES[o];
      t[i] = e(r, n, i);
    }
    return t;
  }, createMethod = function createMethod(t, e) {
    var r = createOutputMethod(t, e, "hex");
    return r.create = function () {
      return new Keccak(t, e, t);
    }, r.update = function (t) {
      return r.create().update(t);
    }, createOutputMethods(r, createOutputMethod, t, e);
  }, createShakeMethod = function createShakeMethod(t, e) {
    var r = createShakeOutputMethod(t, e, "hex");
    return r.create = function (r) {
      return new Keccak(t, e, r);
    }, r.update = function (t, e) {
      return r.create(e).update(t);
    }, createOutputMethods(r, createShakeOutputMethod, t, e);
  }, createCshakeMethod = function createCshakeMethod(t, e) {
    var r = CSHAKE_BYTEPAD[t],
      n = createCshakeOutputMethod(t, e, "hex");
    return n.create = function (n, o, i) {
      return o || i ? new Keccak(t, e, n).bytepad([o, i], r) : methods["shake" + t].create(n);
    }, n.update = function (t, e, r, o) {
      return n.create(e, r, o).update(t);
    }, createOutputMethods(n, createCshakeOutputMethod, t, e);
  }, createKmacMethod = function createKmacMethod(t, e) {
    var r = CSHAKE_BYTEPAD[t],
      n = createKmacOutputMethod(t, e, "hex");
    return n.create = function (n, o, i) {
      return new Kmac(t, e, o).bytepad(["KMAC", i], r).bytepad([n], r);
    }, n.update = function (t, e, r, o) {
      return n.create(t, r, o).update(e);
    }, createOutputMethods(n, createKmacOutputMethod, t, e);
  }, algorithms = [{
    name: "keccak",
    padding: KECCAK_PADDING,
    bits: BITS,
    createMethod: createMethod
  }, {
    name: "sha3",
    padding: PADDING,
    bits: BITS,
    createMethod: createMethod
  }, {
    name: "shake",
    padding: SHAKE_PADDING,
    bits: SHAKE_BITS,
    createMethod: createShakeMethod
  }, {
    name: "cshake",
    padding: CSHAKE_PADDING,
    bits: SHAKE_BITS,
    createMethod: createCshakeMethod
  }, {
    name: "kmac",
    padding: CSHAKE_PADDING,
    bits: SHAKE_BITS,
    createMethod: createKmacMethod
  }], methods = {}, i = 0; i < algorithms.length; ++i) for (var algorithm = algorithms[i], bits = algorithm.bits, j = 0; j < bits.length; ++j) {
  var methodName = algorithm.name + "_" + bits[j];
  if (methods[methodName] = algorithm.createMethod(bits[j], algorithm.padding), "sha3" !== algorithm.name) {
    var newMethodName = algorithm.name + bits[j];
    methods[newMethodName] = methods[methodName];
  }
}
function Keccak(t, e, r) {
  this.blocks = [], this.s = [], this.padding = e, this.outputBits = r, this.reset = !0, this.finalized = !1, this.block = 0, this.start = 0, this.blockCount = 1600 - (t << 1) >> 5, this.byteCount = this.blockCount << 2, this.outputBlocks = r >> 5, this.extraBytes = (31 & r) >> 3;
  for (var n = 0; n < 50; ++n) this.s[n] = 0;
}
function Kmac(t, e, r) {
  Keccak.call(this, t, e, r);
}
Keccak.prototype.update = function (t) {
  if (!this.finalized) {
    var e,
      r = void 0 === t ? "undefined" : _typeof(t);
    if ("string" !== r) {
      if ("object" !== r) throw ERROR;
      if (null === t) throw ERROR;
      if (ARRAY_BUFFER && t.constructor === ArrayBuffer) t = new Uint8Array(t);else if (!(Array.isArray(t) || ARRAY_BUFFER && ArrayBuffer.isView(t))) throw ERROR;
      e = !0;
    }
    for (var n, o, i = this.blocks, a = this.byteCount, u = t.length, s = this.blockCount, c = 0, p = this.s; c < u;) {
      if (this.reset) for (this.reset = !1, i[0] = this.block, n = 1; n < s + 1; ++n) i[n] = 0;
      if (e) for (n = this.start; c < u && n < a; ++c) i[n >> 2] |= t[c] << SHIFT[3 & n++];else for (n = this.start; c < u && n < a; ++c) (o = t.charCodeAt(c)) < 128 ? i[n >> 2] |= o << SHIFT[3 & n++] : o < 2048 ? (i[n >> 2] |= (192 | o >> 6) << SHIFT[3 & n++], i[n >> 2] |= (128 | 63 & o) << SHIFT[3 & n++]) : o < 55296 || o >= 57344 ? (i[n >> 2] |= (224 | o >> 12) << SHIFT[3 & n++], i[n >> 2] |= (128 | o >> 6 & 63) << SHIFT[3 & n++], i[n >> 2] |= (128 | 63 & o) << SHIFT[3 & n++]) : (o = 65536 + ((1023 & o) << 10 | 1023 & t.charCodeAt(++c)), i[n >> 2] |= (240 | o >> 18) << SHIFT[3 & n++], i[n >> 2] |= (128 | o >> 12 & 63) << SHIFT[3 & n++], i[n >> 2] |= (128 | o >> 6 & 63) << SHIFT[3 & n++], i[n >> 2] |= (128 | 63 & o) << SHIFT[3 & n++]);
      if (this.lastByteIndex = n, n >= a) {
        for (this.start = n - a, this.block = i[s], n = 0; n < s; ++n) p[n] ^= i[n];
        f(p), this.reset = !0;
      } else this.start = n;
    }
    return this;
  }
}, Keccak.prototype.encode = function (t, e) {
  var r = 255 & t,
    n = 1,
    o = [r];
  for (r = 255 & (t >>= 8); r > 0;) o.unshift(r), r = 255 & (t >>= 8), ++n;
  return e ? o.push(n) : o.unshift(n), this.update(o), o.length;
}, Keccak.prototype.encodeString = function (t) {
  var e,
    r = void 0 === t ? "undefined" : _typeof(t);
  if ("string" !== r) {
    if ("object" !== r) throw ERROR;
    if (null === t) throw ERROR;
    if (ARRAY_BUFFER && t.constructor === ArrayBuffer) t = new Uint8Array(t);else if (!(Array.isArray(t) || ARRAY_BUFFER && ArrayBuffer.isView(t))) throw ERROR;
    e = !0;
  }
  var n = 0,
    o = t.length;
  if (e) n = o;else for (var i = 0; i < t.length; ++i) {
    var a = t.charCodeAt(i);
    a < 128 ? n += 1 : a < 2048 ? n += 2 : a < 55296 || a >= 57344 ? n += 3 : (a = 65536 + ((1023 & a) << 10 | 1023 & t.charCodeAt(++i)), n += 4);
  }
  return n += this.encode(8 * n), this.update(t), n;
}, Keccak.prototype.bytepad = function (t, e) {
  for (var r = this.encode(e), n = 0; n < t.length; ++n) r += this.encodeString(t[n]);
  var o = e - r % e,
    i = [];
  return i.length = o, this.update(i), this;
}, Keccak.prototype.finalize = function () {
  if (!this.finalized) {
    this.finalized = !0;
    var t = this.blocks,
      e = this.lastByteIndex,
      r = this.blockCount,
      n = this.s;
    if (t[e >> 2] |= this.padding[3 & e], this.lastByteIndex === this.byteCount) for (t[0] = t[r], e = 1; e < r + 1; ++e) t[e] = 0;
    for (t[r - 1] |= 2147483648, e = 0; e < r; ++e) n[e] ^= t[e];
    f(n);
  }
}, Keccak.prototype.toString = Keccak.prototype.hex = function () {
  this.finalize();
  for (var t, e = this.blockCount, r = this.s, n = this.outputBlocks, o = this.extraBytes, i = 0, a = 0, u = ""; a < n;) {
    for (i = 0; i < e && a < n; ++i, ++a) t = r[i], u += HEX_CHARS[t >> 4 & 15] + HEX_CHARS[15 & t] + HEX_CHARS[t >> 12 & 15] + HEX_CHARS[t >> 8 & 15] + HEX_CHARS[t >> 20 & 15] + HEX_CHARS[t >> 16 & 15] + HEX_CHARS[t >> 28 & 15] + HEX_CHARS[t >> 24 & 15];
    a % e == 0 && (f(r), i = 0);
  }
  return o && (t = r[i], u += HEX_CHARS[t >> 4 & 15] + HEX_CHARS[15 & t], o > 1 && (u += HEX_CHARS[t >> 12 & 15] + HEX_CHARS[t >> 8 & 15]), o > 2 && (u += HEX_CHARS[t >> 20 & 15] + HEX_CHARS[t >> 16 & 15])), u;
}, Keccak.prototype.arrayBuffer = function () {
  this.finalize();
  var t,
    e = this.blockCount,
    r = this.s,
    n = this.outputBlocks,
    o = this.extraBytes,
    i = 0,
    a = 0,
    u = this.outputBits >> 3;
  t = o ? new ArrayBuffer(n + 1 << 2) : new ArrayBuffer(u);
  for (var s = new Uint32Array(t); a < n;) {
    for (i = 0; i < e && a < n; ++i, ++a) s[a] = r[i];
    a % e == 0 && f(r);
  }
  return o && (s[i] = r[i], t = t.slice(0, u)), t;
}, Keccak.prototype.buffer = Keccak.prototype.arrayBuffer, Keccak.prototype.digest = Keccak.prototype.array = function () {
  this.finalize();
  for (var t, e, r = this.blockCount, n = this.s, o = this.outputBlocks, i = this.extraBytes, a = 0, u = 0, s = []; u < o;) {
    for (a = 0; a < r && u < o; ++a, ++u) t = u << 2, e = n[a], s[t] = 255 & e, s[t + 1] = e >> 8 & 255, s[t + 2] = e >> 16 & 255, s[t + 3] = e >> 24 & 255;
    u % r == 0 && f(n);
  }
  return i && (t = u << 2, e = n[a], s[t] = 255 & e, i > 1 && (s[t + 1] = e >> 8 & 255), i > 2 && (s[t + 2] = e >> 16 & 255)), s;
}, Kmac.prototype = new Keccak(), Kmac.prototype.finalize = function () {
  return this.encode(this.outputBits, !0), Keccak.prototype.finalize.call(this);
};
var f = function f(t) {
    var e, r, n, o, i, a, u, s, c, p, f, h, l, d, v, y, g, E, b, m, S, w, R, C, A, _, P, I, U, O, k, B, T, N, H, M, x, F, D, X, q, K, V, L, j, Y, z, $, J, Z, W, G, Q, tt, et, rt, nt, ot, it, at, ut, st, ct;
    for (n = 0; n < 48; n += 2) o = t[0] ^ t[10] ^ t[20] ^ t[30] ^ t[40], i = t[1] ^ t[11] ^ t[21] ^ t[31] ^ t[41], a = t[2] ^ t[12] ^ t[22] ^ t[32] ^ t[42], u = t[3] ^ t[13] ^ t[23] ^ t[33] ^ t[43], s = t[4] ^ t[14] ^ t[24] ^ t[34] ^ t[44], c = t[5] ^ t[15] ^ t[25] ^ t[35] ^ t[45], p = t[6] ^ t[16] ^ t[26] ^ t[36] ^ t[46], f = t[7] ^ t[17] ^ t[27] ^ t[37] ^ t[47], e = (h = t[8] ^ t[18] ^ t[28] ^ t[38] ^ t[48]) ^ (a << 1 | u >>> 31), r = (l = t[9] ^ t[19] ^ t[29] ^ t[39] ^ t[49]) ^ (u << 1 | a >>> 31), t[0] ^= e, t[1] ^= r, t[10] ^= e, t[11] ^= r, t[20] ^= e, t[21] ^= r, t[30] ^= e, t[31] ^= r, t[40] ^= e, t[41] ^= r, e = o ^ (s << 1 | c >>> 31), r = i ^ (c << 1 | s >>> 31), t[2] ^= e, t[3] ^= r, t[12] ^= e, t[13] ^= r, t[22] ^= e, t[23] ^= r, t[32] ^= e, t[33] ^= r, t[42] ^= e, t[43] ^= r, e = a ^ (p << 1 | f >>> 31), r = u ^ (f << 1 | p >>> 31), t[4] ^= e, t[5] ^= r, t[14] ^= e, t[15] ^= r, t[24] ^= e, t[25] ^= r, t[34] ^= e, t[35] ^= r, t[44] ^= e, t[45] ^= r, e = s ^ (h << 1 | l >>> 31), r = c ^ (l << 1 | h >>> 31), t[6] ^= e, t[7] ^= r, t[16] ^= e, t[17] ^= r, t[26] ^= e, t[27] ^= r, t[36] ^= e, t[37] ^= r, t[46] ^= e, t[47] ^= r, e = p ^ (o << 1 | i >>> 31), r = f ^ (i << 1 | o >>> 31), t[8] ^= e, t[9] ^= r, t[18] ^= e, t[19] ^= r, t[28] ^= e, t[29] ^= r, t[38] ^= e, t[39] ^= r, t[48] ^= e, t[49] ^= r, d = t[0], v = t[1], Y = t[11] << 4 | t[10] >>> 28, z = t[10] << 4 | t[11] >>> 28, I = t[20] << 3 | t[21] >>> 29, U = t[21] << 3 | t[20] >>> 29, at = t[31] << 9 | t[30] >>> 23, ut = t[30] << 9 | t[31] >>> 23, K = t[40] << 18 | t[41] >>> 14, V = t[41] << 18 | t[40] >>> 14, N = t[2] << 1 | t[3] >>> 31, H = t[3] << 1 | t[2] >>> 31, y = t[13] << 12 | t[12] >>> 20, g = t[12] << 12 | t[13] >>> 20, $ = t[22] << 10 | t[23] >>> 22, J = t[23] << 10 | t[22] >>> 22, O = t[33] << 13 | t[32] >>> 19, k = t[32] << 13 | t[33] >>> 19, st = t[42] << 2 | t[43] >>> 30, ct = t[43] << 2 | t[42] >>> 30, tt = t[5] << 30 | t[4] >>> 2, et = t[4] << 30 | t[5] >>> 2, M = t[14] << 6 | t[15] >>> 26, x = t[15] << 6 | t[14] >>> 26, E = t[25] << 11 | t[24] >>> 21, b = t[24] << 11 | t[25] >>> 21, Z = t[34] << 15 | t[35] >>> 17, W = t[35] << 15 | t[34] >>> 17, B = t[45] << 29 | t[44] >>> 3, T = t[44] << 29 | t[45] >>> 3, C = t[6] << 28 | t[7] >>> 4, A = t[7] << 28 | t[6] >>> 4, rt = t[17] << 23 | t[16] >>> 9, nt = t[16] << 23 | t[17] >>> 9, F = t[26] << 25 | t[27] >>> 7, D = t[27] << 25 | t[26] >>> 7, m = t[36] << 21 | t[37] >>> 11, S = t[37] << 21 | t[36] >>> 11, G = t[47] << 24 | t[46] >>> 8, Q = t[46] << 24 | t[47] >>> 8, L = t[8] << 27 | t[9] >>> 5, j = t[9] << 27 | t[8] >>> 5, _ = t[18] << 20 | t[19] >>> 12, P = t[19] << 20 | t[18] >>> 12, ot = t[29] << 7 | t[28] >>> 25, it = t[28] << 7 | t[29] >>> 25, X = t[38] << 8 | t[39] >>> 24, q = t[39] << 8 | t[38] >>> 24, w = t[48] << 14 | t[49] >>> 18, R = t[49] << 14 | t[48] >>> 18, t[0] = d ^ ~y & E, t[1] = v ^ ~g & b, t[10] = C ^ ~_ & I, t[11] = A ^ ~P & U, t[20] = N ^ ~M & F, t[21] = H ^ ~x & D, t[30] = L ^ ~Y & $, t[31] = j ^ ~z & J, t[40] = tt ^ ~rt & ot, t[41] = et ^ ~nt & it, t[2] = y ^ ~E & m, t[3] = g ^ ~b & S, t[12] = _ ^ ~I & O, t[13] = P ^ ~U & k, t[22] = M ^ ~F & X, t[23] = x ^ ~D & q, t[32] = Y ^ ~$ & Z, t[33] = z ^ ~J & W, t[42] = rt ^ ~ot & at, t[43] = nt ^ ~it & ut, t[4] = E ^ ~m & w, t[5] = b ^ ~S & R, t[14] = I ^ ~O & B, t[15] = U ^ ~k & T, t[24] = F ^ ~X & K, t[25] = D ^ ~q & V, t[34] = $ ^ ~Z & G, t[35] = J ^ ~W & Q, t[44] = ot ^ ~at & st, t[45] = it ^ ~ut & ct, t[6] = m ^ ~w & d, t[7] = S ^ ~R & v, t[16] = O ^ ~B & C, t[17] = k ^ ~T & A, t[26] = X ^ ~K & N, t[27] = q ^ ~V & H, t[36] = Z ^ ~G & L, t[37] = W ^ ~Q & j, t[46] = at ^ ~st & tt, t[47] = ut ^ ~ct & et, t[8] = w ^ ~d & y, t[9] = R ^ ~v & g, t[18] = B ^ ~C & _, t[19] = T ^ ~A & P, t[28] = K ^ ~N & M, t[29] = V ^ ~H & x, t[38] = G ^ ~L & Y, t[39] = Q ^ ~j & z, t[48] = st ^ ~tt & rt, t[49] = ct ^ ~et & nt, t[0] ^= RC[n], t[1] ^= RC[n + 1];
  },
  sha3 = methods,
  keccak256 = sha3.keccak256;
function numberToHex(t) {
  var e = Math.round(t).toString(16);
  return 1 === e.length && (e = "0" + e), e;
}
var cryptoUtils = {
  toHex: function toHex(t) {
    for (var e = "", r = 0; r < t.length; r++) e += numberToHex(t[r]);
    return e;
  },
  toByteArray: function toByteArray(t) {
    for (var e = t, r = []; e.length >= 2;) r.push(parseInt(e.substring(0, 2), 16)), e = e.substring(2, e.length);
    return r;
  },
  sha256: function sha256(t) {
    var e = new _sha("SHA-256", "HEX");
    return e.update(t), e.getHash("HEX");
  },
  sha3: function sha3(t) {
    return keccak256(t);
  }
};
function base(t) {
  for (var e = {}, r = t.length, n = t.charAt(0), o = 0; o < t.length; o++) {
    var i = t.charAt(o);
    if (void 0 !== e[i]) throw new TypeError(i + " is ambiguous");
    e[i] = o;
  }
  function a(t) {
    if ("string" != typeof t) throw new TypeError("Expected String");
    if (0 === t.length) return [];
    for (var o = [0], i = 0; i < t.length; i++) {
      var a = e[t[i]];
      if (void 0 === a) return;
      for (var u = a, s = 0; s < o.length; ++s) u += o[s] * r, o[s] = 255 & u, u >>= 8;
      for (; u > 0;) o.push(255 & u), u >>= 8;
    }
    for (var c = 0; t[c] === n && c < t.length - 1; ++c) o.push(0);
    return o.reverse();
  }
  return {
    encode: function encode(e) {
      if (0 === e.length) return "";
      for (var o = [0], i = 0; i < e.length; ++i) {
        for (var a = e[i], u = 0; u < o.length; ++u) a += o[u] << 8, o[u] = a % r, a = a / r | 0;
        for (; a > 0;) o.push(a % r), a = a / r | 0;
      }
      for (var s = "", c = 0; 0 === e[c] && c < e.length - 1; ++c) s += n;
      for (var p = o.length - 1; p >= 0; --p) s += t[o[p]];
      return s;
    },
    decodeUnsafe: a,
    decode: function decode(t) {
      var e = a(t);
      if (e) return e;
      throw new Error("Non-base" + r + " character");
    }
  };
}
function baseXCheck(t) {
  var e = base(t);
  return {
    encode: function encode(t) {
      var r = cryptoUtils.sha256(cryptoUtils.sha256(t)).slice(0, 8);
      return e.encode(cryptoUtils.toByteArray(t.concat(r)));
    },
    decode: function decode(t) {
      var r = e.decode(t),
        n = r.length,
        o = cryptoUtils.toHex(r.slice(0, n - 4)),
        i = cryptoUtils.sha256(cryptoUtils.sha256(o)).substr(0, 8);
      return cryptoUtils.toHex(r.slice(n - 4, n)) === i ? r.slice(0, n - 4) : null;
    }
  };
}
var alphabet = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
base(alphabet);
var _PREFIXES,
  base58Check = baseXCheck(alphabet),
  BaseValidator = function () {
    function t(e) {
      classCallCheck(this, t), this.supportedCurrencies = e;
    }
    return createClass(t, [{
      key: "isAppliedFor",
      value: function value(t) {
        return this.supportedCurrencies.some(function (e) {
          return e === t;
        });
      }
    }, {
      key: "getSupportedCurrencies",
      value: function value() {
        return this.supportedCurrencies;
      }
    }]), t;
  }(),
  SUPPORTED_CURRENCIES = {
    bitcoin: "BTC",
    litecoin: "LTC",
    dogecoin: "DOGE",
    dash: "DASH",
    bitcoin_cash: "BTH",
    bitcoin_gold: "BTG",
    ethereum: "ETH",
    omise_go: "OMG",
    augur: "REP",
    eos: "EOS",
    fuel: "FUEL",
    status: "SNT",
    singularDTV: "SNGLS",
    genesis_coin: "GEN",
    walton_chain: "WTC",
    ethereum_classic: "ETC",
    monero: "XMR",
    ripple: "XRP",
    zcash: "ZEC",
    tether: "USDT",
    unobtamium: "UNO",
    iota: "IOTA",
    stellar: "XLM",
    neo: "NEO",
    ubiq: "UBQ",
    qtum: "QTUM"
  },
  CHARSET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l",
  GENERATOR = [996825010, 642813549, 513874426, 1027748829, 705979059],
  polymod = function polymod(t) {
    for (var e = 1, r = 0; r < t.length; ++r) {
      var n = e >> 25;
      e = (33554431 & e) << 5 ^ t[r];
      for (var o = 0; o < 5; ++o) n >> o & 1 && (e ^= GENERATOR[o]);
    }
    return e;
  },
  hrpExpand = function hrpExpand(t) {
    for (var e = [], r = 0; r < t.length; ++r) e.push(t.charCodeAt(r) >> 5);
    e.push(0);
    for (var n = 0; n < t.length; ++n) e.push(31 & t.charCodeAt(n));
    return e;
  },
  verifyChecksum = function verifyChecksum(t, e) {
    return 1 === polymod(hrpExpand(t).concat(e));
  },
  createChecksum = function createChecksum(t, e) {
    for (var r = hrpExpand(t).concat(e).concat([0, 0, 0, 0, 0, 0]), n = 1 ^ polymod(r), o = [], i = 0; i < 6; ++i) o.push(n >> 5 * (5 - i) & 31);
    return o;
  },
  encode = function encode(t, e) {
    for (var r = e.concat(createChecksum(t, e)), n = t + "1", o = 0; o < r.length; ++o) n += CHARSET.charAt(r[o]);
    return n;
  },
  decode = function decode(t) {
    var e = void 0,
      r = !1,
      n = !1;
    for (e = 0; e < t.length; ++e) {
      if (t.charCodeAt(e) < 33 || t.charCodeAt(e) > 126) return null;
      t.charCodeAt(e) >= 97 && t.charCodeAt(e) <= 122 && (r = !0), t.charCodeAt(e) >= 65 && t.charCodeAt(e) <= 90 && (n = !0);
    }
    if (r && n) return null;
    var o = (t = t.toLowerCase()).lastIndexOf("1");
    if (o < 1 || o + 7 > t.length || t.length > 90) return null;
    var i = t.substring(0, o),
      a = [];
    for (e = o + 1; e < t.length; ++e) {
      var u = CHARSET.indexOf(t.charAt(e));
      if (-1 === u) return null;
      a.push(u);
    }
    return verifyChecksum(i, a) ? {
      hrp: i,
      data: a.slice(0, a.length - 6)
    } : null;
  },
  convertbits = function convertbits(t, e, r, n) {
    for (var o = 0, i = 0, a = [], u = (1 << r) - 1, s = 0; s < t.length; ++s) {
      var c = t[s];
      if (c < 0 || c >> e != 0) return null;
      for (o = o << e | c, i += e; i >= r;) i -= r, a.push(o >> i & u);
    }
    if (n) i > 0 && a.push(o << r - i & u);else if (i >= e || o << r - i & u) return null;
    return a;
  },
  decode$1 = function decode$1(t, e) {
    var r = decode(e);
    if (null === r || r.hrp !== t || r.data.length < 1 || r.data[0] > 16) return null;
    var n = convertbits(r.data.slice(1), 5, 8, !1);
    return null === n || n.length < 2 || n.length > 40 ? null : 0 === r.data[0] && 20 !== n.length && 32 !== n.length ? null : {
      version: r.data[0],
      program: n
    };
  },
  encode$1 = function encode$1(t, e, r) {
    var n = encode(t, [e].concat(convertbits(r, 8, 5, !0)));
    return null === decode$1(t, n) ? null : n;
  },
  isValidAddress = function isValidAddress(t, e) {
    if (!t) return !1;
    var r = e || "bc",
      n = decode$1(r, t);
    return null === n && (n = decode$1(r = "tb", t)), null !== n && encode$1(r, n.version, n.program) === t.toLowerCase();
  },
  BITCOIN_PREFIXES = {
    prod: ["00", "05"],
    testnet: ["6f", "c4"]
  },
  PREFIXES = (defineProperty(_PREFIXES = {}, SUPPORTED_CURRENCIES.bitcoin, BITCOIN_PREFIXES), defineProperty(_PREFIXES, SUPPORTED_CURRENCIES.tether, BITCOIN_PREFIXES), defineProperty(_PREFIXES, SUPPORTED_CURRENCIES.litecoin, {
    prod: ["30", "05", "32"],
    testnet: ["6f", "c4", "3a"]
  }), defineProperty(_PREFIXES, SUPPORTED_CURRENCIES.dogecoin, {
    prod: ["1e", "16"],
    testnet: ["71", "c4"]
  }), defineProperty(_PREFIXES, SUPPORTED_CURRENCIES.dash, {
    prod: ["4c", "10"],
    testnet: ["8c", "13"]
  }), defineProperty(_PREFIXES, SUPPORTED_CURRENCIES.bitcoin_gold, {
    prod: ["26", "17"]
  }), defineProperty(_PREFIXES, SUPPORTED_CURRENCIES.zcash, {
    prod: ["1cb8", "1cbd"],
    testnet: ["1d25", "1cba"]
  }), defineProperty(_PREFIXES, SUPPORTED_CURRENCIES.unobtamium, {
    prod: ["82", "1e"],
    testnet: ["44", "1e"]
  }), defineProperty(_PREFIXES, SUPPORTED_CURRENCIES.neo, {
    prod: ["17"]
  }), defineProperty(_PREFIXES, SUPPORTED_CURRENCIES.qtum, {
    prod: ["3a", "32"],
    testnet: ["78", "6e"]
  }), _PREFIXES),
  DefaultValidator = function (t) {
    function e() {
      return classCallCheck(this, e), possibleConstructorReturn(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, Object.keys(PREFIXES)));
    }
    return inherits(e, BaseValidator), createClass(e, [{
      key: "getAddressPrefix",
      value: function value(t, e) {
        var r = void 0;
        try {
          r = base58Check.decode(t);
        } catch (t) {
          return null;
        }
        return r ? cryptoUtils.toHex(r.slice(0, e)) : null;
      }
    }, {
      key: "validate",
      value: function value(t, e) {
        var r = this.getAddressTypes(e),
          n = this.getPrefixLength(r),
          o = this.getAddressPrefix(t, n);
        return r.indexOf(o) >= 0 || isValidAddress(t);
      }
    }, {
      key: "getAddressTypes",
      value: function value(t) {
        var e = PREFIXES[t];
        return e.prod.concat(e.testnet);
      }
    }, {
      key: "getPrefixLength",
      value: function value(t) {
        return t[0].length / 2;
      }
    }]), e;
  }(),
  BigInteger = createCommonjsModule(function (t) {
    var e = function (t) {
      var r = 1e7,
        n = 7,
        o = 9007199254740992,
        i = l(o),
        a = "0123456789abcdefghijklmnopqrstuvwxyz",
        u = "function" == typeof BigInt;
      function s(t, e, r, n) {
        return void 0 === t ? s[0] : void 0 !== e && (10 != +e || r) ? L(t, e, r, n) : J(t);
      }
      function c(t, e) {
        this.value = t, this.sign = e, this.isSmall = !1;
      }
      function p(t) {
        this.value = t, this.sign = t < 0, this.isSmall = !0;
      }
      function f(t) {
        this.value = t;
      }
      function h(t) {
        return -o < t && t < o;
      }
      function l(t) {
        return t < 1e7 ? [t] : t < 1e14 ? [t % 1e7, Math.floor(t / 1e7)] : [t % 1e7, Math.floor(t / 1e7) % 1e7, Math.floor(t / 1e14)];
      }
      function d(t) {
        v(t);
        var e = t.length;
        if (e < 4 && O(t, i) < 0) switch (e) {
          case 0:
            return 0;
          case 1:
            return t[0];
          case 2:
            return t[0] + t[1] * r;
          default:
            return t[0] + (t[1] + t[2] * r) * r;
        }
        return t;
      }
      function v(t) {
        for (var e = t.length; 0 === t[--e];);
        t.length = e + 1;
      }
      function y(t) {
        for (var e = new Array(t), r = -1; ++r < t;) e[r] = 0;
        return e;
      }
      function g(t) {
        return t > 0 ? Math.floor(t) : Math.ceil(t);
      }
      function E(t, e) {
        var n,
          o,
          i = t.length,
          a = e.length,
          u = new Array(i),
          s = 0,
          c = r;
        for (o = 0; o < a; o++) s = (n = t[o] + e[o] + s) >= c ? 1 : 0, u[o] = n - s * c;
        for (; o < i;) s = (n = t[o] + s) === c ? 1 : 0, u[o++] = n - s * c;
        return s > 0 && u.push(s), u;
      }
      function b(t, e) {
        return t.length >= e.length ? E(t, e) : E(e, t);
      }
      function m(t, e) {
        var n,
          o,
          i = t.length,
          a = new Array(i),
          u = r;
        for (o = 0; o < i; o++) n = t[o] - u + e, e = Math.floor(n / u), a[o] = n - e * u, e += 1;
        for (; e > 0;) a[o++] = e % u, e = Math.floor(e / u);
        return a;
      }
      function S(t, e) {
        var n,
          o,
          i = t.length,
          a = e.length,
          u = new Array(i),
          s = 0,
          c = r;
        for (n = 0; n < a; n++) (o = t[n] - s - e[n]) < 0 ? (o += c, s = 1) : s = 0, u[n] = o;
        for (n = a; n < i; n++) {
          if (!((o = t[n] - s) < 0)) {
            u[n++] = o;
            break;
          }
          o += c, u[n] = o;
        }
        for (; n < i; n++) u[n] = t[n];
        return v(u), u;
      }
      function w(t, e, n) {
        var o,
          i,
          a = t.length,
          u = new Array(a),
          s = -e,
          f = r;
        for (o = 0; o < a; o++) i = t[o] + s, s = Math.floor(i / f), i %= f, u[o] = i < 0 ? i + f : i;
        return "number" == typeof (u = d(u)) ? (n && (u = -u), new p(u)) : new c(u, n);
      }
      function R(t, e) {
        var n,
          o,
          i,
          a,
          u = t.length,
          s = e.length,
          c = y(u + s),
          p = r;
        for (i = 0; i < u; ++i) {
          a = t[i];
          for (var f = 0; f < s; ++f) n = a * e[f] + c[i + f], o = Math.floor(n / p), c[i + f] = n - o * p, c[i + f + 1] += o;
        }
        return v(c), c;
      }
      function C(t, e) {
        var n,
          o,
          i = t.length,
          a = new Array(i),
          u = r,
          s = 0;
        for (o = 0; o < i; o++) n = t[o] * e + s, s = Math.floor(n / u), a[o] = n - s * u;
        for (; s > 0;) a[o++] = s % u, s = Math.floor(s / u);
        return a;
      }
      function A(t, e) {
        for (var r = []; e-- > 0;) r.push(0);
        return r.concat(t);
      }
      function _(t, e, n) {
        return new c(t < r ? C(e, t) : R(e, l(t)), n);
      }
      function P(t) {
        var e,
          n,
          o,
          i,
          a = t.length,
          u = y(a + a),
          s = r;
        for (o = 0; o < a; o++) {
          n = 0 - (i = t[o]) * i;
          for (var c = o; c < a; c++) e = i * t[c] * 2 + u[o + c] + n, n = Math.floor(e / s), u[o + c] = e - n * s;
          u[o + a] = n;
        }
        return v(u), u;
      }
      function I(t, e) {
        var n,
          o,
          i,
          a,
          u = t.length,
          s = y(u),
          c = r;
        for (i = 0, n = u - 1; n >= 0; --n) i = (a = i * c + t[n]) - (o = g(a / e)) * e, s[n] = 0 | o;
        return [s, 0 | i];
      }
      function U(t, e) {
        var n,
          o = J(e);
        if (u) return [new f(t.value / o.value), new f(t.value % o.value)];
        var i,
          a = t.value,
          h = o.value;
        if (0 === h) throw new Error("Cannot divide by zero");
        if (t.isSmall) return o.isSmall ? [new p(g(a / h)), new p(a % h)] : [s[0], t];
        if (o.isSmall) {
          if (1 === h) return [t, s[0]];
          if (-1 == h) return [t.negate(), s[0]];
          var E = Math.abs(h);
          if (E < r) {
            i = d((n = I(a, E))[0]);
            var b = n[1];
            return t.sign && (b = -b), "number" == typeof i ? (t.sign !== o.sign && (i = -i), [new p(i), new p(b)]) : [new c(i, t.sign !== o.sign), new p(b)];
          }
          h = l(E);
        }
        var m = O(a, h);
        if (-1 === m) return [s[0], t];
        if (0 === m) return [s[t.sign === o.sign ? 1 : -1], s[0]];
        i = (n = a.length + h.length <= 200 ? function (t, e) {
          var n,
            o,
            i,
            a,
            u,
            s,
            c,
            p = t.length,
            f = e.length,
            h = r,
            l = y(e.length),
            v = e[f - 1],
            g = Math.ceil(h / (2 * v)),
            E = C(t, g),
            b = C(e, g);
          for (E.length <= p && E.push(0), b.push(0), v = b[f - 1], o = p - f; o >= 0; o--) {
            for (n = h - 1, E[o + f] !== v && (n = Math.floor((E[o + f] * h + E[o + f - 1]) / v)), i = 0, a = 0, s = b.length, u = 0; u < s; u++) i += n * b[u], c = Math.floor(i / h), a += E[o + u] - (i - c * h), i = c, a < 0 ? (E[o + u] = a + h, a = -1) : (E[o + u] = a, a = 0);
            for (; 0 !== a;) {
              for (n -= 1, i = 0, u = 0; u < s; u++) (i += E[o + u] - h + b[u]) < 0 ? (E[o + u] = i + h, i = 0) : (E[o + u] = i, i = 1);
              a += i;
            }
            l[o] = n;
          }
          return E = I(E, g)[0], [d(l), d(E)];
        }(a, h) : function (t, e) {
          for (var n, o, i, a, u, s = t.length, c = e.length, p = [], f = [], h = r; s;) if (f.unshift(t[--s]), v(f), O(f, e) < 0) p.push(0);else {
            i = f[(o = f.length) - 1] * h + f[o - 2], a = e[c - 1] * h + e[c - 2], o > c && (i = (i + 1) * h), n = Math.ceil(i / a);
            do {
              if (O(u = C(e, n), f) <= 0) break;
              n--;
            } while (n);
            p.push(n), f = S(f, u);
          }
          return p.reverse(), [d(p), d(f)];
        }(a, h))[0];
        var w = t.sign !== o.sign,
          R = n[1],
          A = t.sign;
        return "number" == typeof i ? (w && (i = -i), i = new p(i)) : i = new c(i, w), "number" == typeof R ? (A && (R = -R), R = new p(R)) : R = new c(R, A), [i, R];
      }
      function O(t, e) {
        if (t.length !== e.length) return t.length > e.length ? 1 : -1;
        for (var r = t.length - 1; r >= 0; r--) if (t[r] !== e[r]) return t[r] > e[r] ? 1 : -1;
        return 0;
      }
      function k(t) {
        var e = t.abs();
        return !e.isUnit() && (!!(e.equals(2) || e.equals(3) || e.equals(5)) || !(e.isEven() || e.isDivisibleBy(3) || e.isDivisibleBy(5)) && (!!e.lesser(49) || void 0));
      }
      function B(t, r) {
        for (var n, o, i, a = t.prev(), u = a, s = 0; u.isEven();) u = u.divide(2), s++;
        t: for (o = 0; o < r.length; o++) if (!t.lesser(r[o]) && !(i = e(r[o]).modPow(u, t)).isUnit() && !i.equals(a)) {
          for (n = s - 1; 0 != n; n--) {
            if ((i = i.square().mod(t)).isUnit()) return !1;
            if (i.equals(a)) continue t;
          }
          return !1;
        }
        return !0;
      }
      c.prototype = Object.create(s.prototype), p.prototype = Object.create(s.prototype), f.prototype = Object.create(s.prototype), c.prototype.add = function (t) {
        var e = J(t);
        if (this.sign !== e.sign) return this.subtract(e.negate());
        var r = this.value,
          n = e.value;
        return e.isSmall ? new c(m(r, Math.abs(n)), this.sign) : new c(b(r, n), this.sign);
      }, c.prototype.plus = c.prototype.add, p.prototype.add = function (t) {
        var e = J(t),
          r = this.value;
        if (r < 0 !== e.sign) return this.subtract(e.negate());
        var n = e.value;
        if (e.isSmall) {
          if (h(r + n)) return new p(r + n);
          n = l(Math.abs(n));
        }
        return new c(m(n, Math.abs(r)), r < 0);
      }, p.prototype.plus = p.prototype.add, f.prototype.add = function (t) {
        return new f(this.value + J(t).value);
      }, f.prototype.plus = f.prototype.add, c.prototype.subtract = function (t) {
        var e = J(t);
        if (this.sign !== e.sign) return this.add(e.negate());
        var r = this.value,
          n = e.value;
        return e.isSmall ? w(r, Math.abs(n), this.sign) : function (t, e, r) {
          var n;
          return O(t, e) >= 0 ? n = S(t, e) : (n = S(e, t), r = !r), "number" == typeof (n = d(n)) ? (r && (n = -n), new p(n)) : new c(n, r);
        }(r, n, this.sign);
      }, c.prototype.minus = c.prototype.subtract, p.prototype.subtract = function (t) {
        var e = J(t),
          r = this.value;
        if (r < 0 !== e.sign) return this.add(e.negate());
        var n = e.value;
        return e.isSmall ? new p(r - n) : w(n, Math.abs(r), r >= 0);
      }, p.prototype.minus = p.prototype.subtract, f.prototype.subtract = function (t) {
        return new f(this.value - J(t).value);
      }, f.prototype.minus = f.prototype.subtract, c.prototype.negate = function () {
        return new c(this.value, !this.sign);
      }, p.prototype.negate = function () {
        var t = this.sign,
          e = new p(-this.value);
        return e.sign = !t, e;
      }, f.prototype.negate = function () {
        return new f(-this.value);
      }, c.prototype.abs = function () {
        return new c(this.value, !1);
      }, p.prototype.abs = function () {
        return new p(Math.abs(this.value));
      }, f.prototype.abs = function () {
        return new f(this.value >= 0 ? this.value : -this.value);
      }, c.prototype.multiply = function (t) {
        var e,
          n,
          o,
          i = J(t),
          a = this.value,
          u = i.value,
          p = this.sign !== i.sign;
        if (i.isSmall) {
          if (0 === u) return s[0];
          if (1 === u) return this;
          if (-1 === u) return this.negate();
          if ((e = Math.abs(u)) < r) return new c(C(a, e), p);
          u = l(e);
        }
        return n = a.length, o = u.length, new c(-.012 * n - .012 * o + 15e-6 * n * o > 0 ? function t(e, r) {
          var n = Math.max(e.length, r.length);
          if (n <= 30) return R(e, r);
          n = Math.ceil(n / 2);
          var o = e.slice(n),
            i = e.slice(0, n),
            a = r.slice(n),
            u = r.slice(0, n),
            s = t(i, u),
            c = t(o, a),
            p = b(b(s, A(S(S(t(b(i, o), b(u, a)), s), c), n)), A(c, 2 * n));
          return v(p), p;
        }(a, u) : R(a, u), p);
      }, c.prototype.times = c.prototype.multiply, p.prototype._multiplyBySmall = function (t) {
        return h(t.value * this.value) ? new p(t.value * this.value) : _(Math.abs(t.value), l(Math.abs(this.value)), this.sign !== t.sign);
      }, c.prototype._multiplyBySmall = function (t) {
        return 0 === t.value ? s[0] : 1 === t.value ? this : -1 === t.value ? this.negate() : _(Math.abs(t.value), this.value, this.sign !== t.sign);
      }, p.prototype.multiply = function (t) {
        return J(t)._multiplyBySmall(this);
      }, p.prototype.times = p.prototype.multiply, f.prototype.multiply = function (t) {
        return new f(this.value * J(t).value);
      }, f.prototype.times = f.prototype.multiply, c.prototype.square = function () {
        return new c(P(this.value), !1);
      }, p.prototype.square = function () {
        var t = this.value * this.value;
        return h(t) ? new p(t) : new c(P(l(Math.abs(this.value))), !1);
      }, f.prototype.square = function (t) {
        return new f(this.value * this.value);
      }, c.prototype.divmod = function (t) {
        var e = U(this, t);
        return {
          quotient: e[0],
          remainder: e[1]
        };
      }, f.prototype.divmod = p.prototype.divmod = c.prototype.divmod, c.prototype.divide = function (t) {
        return U(this, t)[0];
      }, f.prototype.over = f.prototype.divide = function (t) {
        return new f(this.value / J(t).value);
      }, p.prototype.over = p.prototype.divide = c.prototype.over = c.prototype.divide, c.prototype.mod = function (t) {
        return U(this, t)[1];
      }, f.prototype.mod = f.prototype.remainder = function (t) {
        return new f(this.value % J(t).value);
      }, p.prototype.remainder = p.prototype.mod = c.prototype.remainder = c.prototype.mod, c.prototype.pow = function (t) {
        var e,
          r,
          n,
          o = J(t),
          i = this.value,
          a = o.value;
        if (0 === a) return s[1];
        if (0 === i) return s[0];
        if (1 === i) return s[1];
        if (-1 === i) return o.isEven() ? s[1] : s[-1];
        if (o.sign) return s[0];
        if (!o.isSmall) throw new Error("The exponent " + o.toString() + " is too large.");
        if (this.isSmall && h(e = Math.pow(i, a))) return new p(g(e));
        for (r = this, n = s[1]; !0 & a && (n = n.times(r), --a), 0 !== a;) a /= 2, r = r.square();
        return n;
      }, p.prototype.pow = c.prototype.pow, f.prototype.pow = function (t) {
        var e = J(t),
          r = this.value,
          n = e.value,
          o = BigInt(0),
          i = BigInt(1),
          a = BigInt(2);
        if (n === o) return s[1];
        if (r === o) return s[0];
        if (r === i) return s[1];
        if (r === BigInt(-1)) return e.isEven() ? s[1] : s[-1];
        if (e.isNegative()) return new f(o);
        for (var u = this, c = s[1]; (n & i) === i && (c = c.times(u), --n), n !== o;) n /= a, u = u.square();
        return c;
      }, c.prototype.modPow = function (t, e) {
        if (t = J(t), (e = J(e)).isZero()) throw new Error("Cannot take modPow with modulus 0");
        for (var r = s[1], n = this.mod(e); t.isPositive();) {
          if (n.isZero()) return s[0];
          t.isOdd() && (r = r.multiply(n).mod(e)), t = t.divide(2), n = n.square().mod(e);
        }
        return r;
      }, f.prototype.modPow = p.prototype.modPow = c.prototype.modPow, c.prototype.compareAbs = function (t) {
        var e = J(t),
          r = this.value,
          n = e.value;
        return e.isSmall ? 1 : O(r, n);
      }, p.prototype.compareAbs = function (t) {
        var e = J(t),
          r = Math.abs(this.value),
          n = e.value;
        return e.isSmall ? r === (n = Math.abs(n)) ? 0 : r > n ? 1 : -1 : -1;
      }, f.prototype.compareAbs = function (t) {
        var e = this.value,
          r = J(t).value;
        return (e = e >= 0 ? e : -e) === (r = r >= 0 ? r : -r) ? 0 : e > r ? 1 : -1;
      }, c.prototype.compare = function (t) {
        if (t === 1 / 0) return -1;
        if (t === -1 / 0) return 1;
        var e = J(t),
          r = this.value,
          n = e.value;
        return this.sign !== e.sign ? e.sign ? 1 : -1 : e.isSmall ? this.sign ? -1 : 1 : O(r, n) * (this.sign ? -1 : 1);
      }, c.prototype.compareTo = c.prototype.compare, p.prototype.compare = function (t) {
        if (t === 1 / 0) return -1;
        if (t === -1 / 0) return 1;
        var e = J(t),
          r = this.value,
          n = e.value;
        return e.isSmall ? r == n ? 0 : r > n ? 1 : -1 : r < 0 !== e.sign ? r < 0 ? -1 : 1 : r < 0 ? 1 : -1;
      }, p.prototype.compareTo = p.prototype.compare, f.prototype.compare = function (t) {
        if (t === 1 / 0) return -1;
        if (t === -1 / 0) return 1;
        var e = this.value,
          r = J(t).value;
        return e === r ? 0 : e > r ? 1 : -1;
      }, f.prototype.compareTo = f.prototype.compare, c.prototype.equals = function (t) {
        return 0 === this.compare(t);
      }, f.prototype.eq = f.prototype.equals = p.prototype.eq = p.prototype.equals = c.prototype.eq = c.prototype.equals, c.prototype.notEquals = function (t) {
        return 0 !== this.compare(t);
      }, f.prototype.neq = f.prototype.notEquals = p.prototype.neq = p.prototype.notEquals = c.prototype.neq = c.prototype.notEquals, c.prototype.greater = function (t) {
        return this.compare(t) > 0;
      }, f.prototype.gt = f.prototype.greater = p.prototype.gt = p.prototype.greater = c.prototype.gt = c.prototype.greater, c.prototype.lesser = function (t) {
        return this.compare(t) < 0;
      }, f.prototype.lt = f.prototype.lesser = p.prototype.lt = p.prototype.lesser = c.prototype.lt = c.prototype.lesser, c.prototype.greaterOrEquals = function (t) {
        return this.compare(t) >= 0;
      }, f.prototype.geq = f.prototype.greaterOrEquals = p.prototype.geq = p.prototype.greaterOrEquals = c.prototype.geq = c.prototype.greaterOrEquals, c.prototype.lesserOrEquals = function (t) {
        return this.compare(t) <= 0;
      }, f.prototype.leq = f.prototype.lesserOrEquals = p.prototype.leq = p.prototype.lesserOrEquals = c.prototype.leq = c.prototype.lesserOrEquals, c.prototype.isEven = function () {
        return 0 == (1 & this.value[0]);
      }, p.prototype.isEven = function () {
        return 0 == (1 & this.value);
      }, f.prototype.isEven = function () {
        return (this.value & BigInt(1)) === BigInt(0);
      }, c.prototype.isOdd = function () {
        return 1 == (1 & this.value[0]);
      }, p.prototype.isOdd = function () {
        return 1 == (1 & this.value);
      }, f.prototype.isOdd = function () {
        return (this.value & BigInt(1)) === BigInt(1);
      }, c.prototype.isPositive = function () {
        return !this.sign;
      }, p.prototype.isPositive = function () {
        return this.value > 0;
      }, f.prototype.isPositive = p.prototype.isPositive, c.prototype.isNegative = function () {
        return this.sign;
      }, p.prototype.isNegative = function () {
        return this.value < 0;
      }, f.prototype.isNegative = p.prototype.isNegative, c.prototype.isUnit = function () {
        return !1;
      }, p.prototype.isUnit = function () {
        return 1 === Math.abs(this.value);
      }, f.prototype.isUnit = function () {
        return this.abs().value === BigInt(1);
      }, c.prototype.isZero = function () {
        return !1;
      }, p.prototype.isZero = function () {
        return 0 === this.value;
      }, f.prototype.isZero = function () {
        return this.value === BigInt(0);
      }, c.prototype.isDivisibleBy = function (t) {
        var e = J(t);
        return !e.isZero() && (!!e.isUnit() || (0 === e.compareAbs(2) ? this.isEven() : this.mod(e).isZero()));
      }, f.prototype.isDivisibleBy = p.prototype.isDivisibleBy = c.prototype.isDivisibleBy, c.prototype.isPrime = function (t) {
        var r = k(this);
        if (void 0 !== r) return r;
        var n = this.abs(),
          o = n.bitLength();
        if (o <= 64) return B(n, [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37]);
        for (var i = Math.log(2) * o.toJSNumber(), a = Math.ceil(!0 === t ? 2 * Math.pow(i, 2) : i), u = [], s = 0; s < a; s++) u.push(e(s + 2));
        return B(n, u);
      }, f.prototype.isPrime = p.prototype.isPrime = c.prototype.isPrime, c.prototype.isProbablePrime = function (t) {
        var r = k(this);
        if (void 0 !== r) return r;
        for (var n = this.abs(), o = void 0 === t ? 5 : t, i = [], a = 0; a < o; a++) i.push(e.randBetween(2, n.minus(2)));
        return B(n, i);
      }, f.prototype.isProbablePrime = p.prototype.isProbablePrime = c.prototype.isProbablePrime, c.prototype.modInv = function (t) {
        for (var r, n, o, i = e.zero, a = e.one, u = J(t), s = this.abs(); !s.isZero();) r = u.divide(s), n = i, o = u, i = a, u = s, a = n.subtract(r.multiply(a)), s = o.subtract(r.multiply(s));
        if (!u.isUnit()) throw new Error(this.toString() + " and " + t.toString() + " are not co-prime");
        return -1 === i.compare(0) && (i = i.add(t)), this.isNegative() ? i.negate() : i;
      }, f.prototype.modInv = p.prototype.modInv = c.prototype.modInv, c.prototype.next = function () {
        var t = this.value;
        return this.sign ? w(t, 1, this.sign) : new c(m(t, 1), this.sign);
      }, p.prototype.next = function () {
        var t = this.value;
        return t + 1 < o ? new p(t + 1) : new c(i, !1);
      }, f.prototype.next = function () {
        return new f(this.value + BigInt(1));
      }, c.prototype.prev = function () {
        var t = this.value;
        return this.sign ? new c(m(t, 1), !0) : w(t, 1, this.sign);
      }, p.prototype.prev = function () {
        var t = this.value;
        return t - 1 > -o ? new p(t - 1) : new c(i, !0);
      }, f.prototype.prev = function () {
        return new f(this.value - BigInt(1));
      };
      for (var T = [1]; 2 * T[T.length - 1] <= r;) T.push(2 * T[T.length - 1]);
      var N = T.length,
        H = T[N - 1];
      function M(t) {
        return Math.abs(t) <= r;
      }
      function x(t, r, n) {
        r = J(r);
        for (var o = t.isNegative(), i = r.isNegative(), a = o ? t.not() : t, u = i ? r.not() : r, s = 0, c = 0, p = null, f = null, h = []; !a.isZero() || !u.isZero();) s = (p = U(a, H))[1].toJSNumber(), o && (s = H - 1 - s), c = (f = U(u, H))[1].toJSNumber(), i && (c = H - 1 - c), a = p[0], u = f[0], h.push(n(s, c));
        for (var l = 0 !== n(o ? 1 : 0, i ? 1 : 0) ? e(-1) : e(0), d = h.length - 1; d >= 0; d -= 1) l = l.multiply(H).add(e(h[d]));
        return l;
      }
      c.prototype.shiftLeft = function (t) {
        var e = J(t).toJSNumber();
        if (!M(e)) throw new Error(String(e) + " is too large for shifting.");
        if (e < 0) return this.shiftRight(-e);
        var r = this;
        if (r.isZero()) return r;
        for (; e >= N;) r = r.multiply(H), e -= N - 1;
        return r.multiply(T[e]);
      }, f.prototype.shiftLeft = p.prototype.shiftLeft = c.prototype.shiftLeft, c.prototype.shiftRight = function (t) {
        var e,
          r = J(t).toJSNumber();
        if (!M(r)) throw new Error(String(r) + " is too large for shifting.");
        if (r < 0) return this.shiftLeft(-r);
        for (var n = this; r >= N;) {
          if (n.isZero() || n.isNegative() && n.isUnit()) return n;
          n = (e = U(n, H))[1].isNegative() ? e[0].prev() : e[0], r -= N - 1;
        }
        return (e = U(n, T[r]))[1].isNegative() ? e[0].prev() : e[0];
      }, f.prototype.shiftRight = p.prototype.shiftRight = c.prototype.shiftRight, c.prototype.not = function () {
        return this.negate().prev();
      }, f.prototype.not = p.prototype.not = c.prototype.not, c.prototype.and = function (t) {
        return x(this, t, function (t, e) {
          return t & e;
        });
      }, f.prototype.and = p.prototype.and = c.prototype.and, c.prototype.or = function (t) {
        return x(this, t, function (t, e) {
          return t | e;
        });
      }, f.prototype.or = p.prototype.or = c.prototype.or, c.prototype.xor = function (t) {
        return x(this, t, function (t, e) {
          return t ^ e;
        });
      }, f.prototype.xor = p.prototype.xor = c.prototype.xor;
      var F = 1 << 30,
        D = (r & -r) * (r & -r) | F;
      function X(t) {
        var e = t.value,
          n = "number" == typeof e ? e | F : "bigint" == typeof e ? e | BigInt(F) : e[0] + e[1] * r | D;
        return n & -n;
      }
      function q(t, e) {
        return t = J(t), e = J(e), t.greater(e) ? t : e;
      }
      function K(t, e) {
        return t = J(t), e = J(e), t.lesser(e) ? t : e;
      }
      function V(t, e) {
        if (t = J(t).abs(), e = J(e).abs(), t.equals(e)) return t;
        if (t.isZero()) return e;
        if (e.isZero()) return t;
        for (var r, n, o = s[1]; t.isEven() && e.isEven();) r = K(X(t), X(e)), t = t.divide(r), e = e.divide(r), o = o.multiply(r);
        for (; t.isEven();) t = t.divide(X(t));
        do {
          for (; e.isEven();) e = e.divide(X(e));
          t.greater(e) && (n = e, e = t, t = n), e = e.subtract(t);
        } while (!e.isZero());
        return o.isUnit() ? t : t.multiply(o);
      }
      c.prototype.bitLength = function () {
        var t = this;
        return t.compareTo(e(0)) < 0 && (t = t.negate().subtract(e(1))), 0 === t.compareTo(e(0)) ? e(0) : e(function t(r, n) {
          if (n.compareTo(r) <= 0) {
            var o = t(r, n.square(n)),
              i = o.p,
              a = o.e,
              u = i.multiply(n);
            return u.compareTo(r) <= 0 ? {
              p: u,
              e: 2 * a + 1
            } : {
              p: i,
              e: 2 * a
            };
          }
          return {
            p: e(1),
            e: 0
          };
        }(t, e(2)).e).add(e(1));
      }, f.prototype.bitLength = p.prototype.bitLength = c.prototype.bitLength;
      var L = function L(t, e, r, n) {
        r = r || a, t = String(t), n || (t = t.toLowerCase(), r = r.toLowerCase());
        var o,
          i = t.length,
          u = Math.abs(e),
          s = {};
        for (o = 0; o < r.length; o++) s[r[o]] = o;
        for (o = 0; o < i; o++) {
          if ("-" !== (f = t[o]) && f in s && s[f] >= u) {
            if ("1" === f && 1 === u) continue;
            throw new Error(f + " is not a valid digit in base " + e + ".");
          }
        }
        e = J(e);
        var c = [],
          p = "-" === t[0];
        for (o = p ? 1 : 0; o < t.length; o++) {
          var f;
          if ((f = t[o]) in s) c.push(J(s[f]));else {
            if ("<" !== f) throw new Error(f + " is not a valid character");
            var h = o;
            do {
              o++;
            } while (">" !== t[o] && o < t.length);
            c.push(J(t.slice(h + 1, o)));
          }
        }
        return j(c, e, p);
      };
      function j(t, e, r) {
        var n,
          o = s[0],
          i = s[1];
        for (n = t.length - 1; n >= 0; n--) o = o.add(t[n].times(i)), i = i.times(e);
        return r ? o.negate() : o;
      }
      function Y(t, r) {
        if ((r = e(r)).isZero()) {
          if (t.isZero()) return {
            value: [0],
            isNegative: !1
          };
          throw new Error("Cannot convert nonzero numbers to base 0.");
        }
        if (r.equals(-1)) {
          if (t.isZero()) return {
            value: [0],
            isNegative: !1
          };
          if (t.isNegative()) return {
            value: [].concat.apply([], Array.apply(null, Array(-t.toJSNumber())).map(Array.prototype.valueOf, [1, 0])),
            isNegative: !1
          };
          var n = Array.apply(null, Array(t.toJSNumber() - 1)).map(Array.prototype.valueOf, [0, 1]);
          return n.unshift([1]), {
            value: [].concat.apply([], n),
            isNegative: !1
          };
        }
        var o = !1;
        if (t.isNegative() && r.isPositive() && (o = !0, t = t.abs()), r.isUnit()) return t.isZero() ? {
          value: [0],
          isNegative: !1
        } : {
          value: Array.apply(null, Array(t.toJSNumber())).map(Number.prototype.valueOf, 1),
          isNegative: o
        };
        for (var i, a = [], u = t; u.isNegative() || u.compareAbs(r) >= 0;) {
          u = (i = u.divmod(r)).quotient;
          var s = i.remainder;
          s.isNegative() && (s = r.minus(s).abs(), u = u.next()), a.push(s.toJSNumber());
        }
        return a.push(u.toJSNumber()), {
          value: a.reverse(),
          isNegative: o
        };
      }
      function z(t, e, r) {
        var n = Y(t, e);
        return (n.isNegative ? "-" : "") + n.value.map(function (t) {
          return function (t, e) {
            return t < (e = e || a).length ? e[t] : "<" + t + ">";
          }(t, r);
        }).join("");
      }
      function $(t) {
        if (h(+t)) {
          var e = +t;
          if (e === g(e)) return u ? new f(BigInt(e)) : new p(e);
          throw new Error("Invalid integer: " + t);
        }
        var r = "-" === t[0];
        r && (t = t.slice(1));
        var o = t.split(/e/i);
        if (o.length > 2) throw new Error("Invalid integer: " + o.join("e"));
        if (2 === o.length) {
          var i = o[1];
          if ("+" === i[0] && (i = i.slice(1)), (i = +i) !== g(i) || !h(i)) throw new Error("Invalid integer: " + i + " is not a valid exponent.");
          var a = o[0],
            s = a.indexOf(".");
          if (s >= 0 && (i -= a.length - s - 1, a = a.slice(0, s) + a.slice(s + 1)), i < 0) throw new Error("Cannot include negative exponent part for integers");
          t = a += new Array(i + 1).join("0");
        }
        if (!/^([0-9][0-9]*)$/.test(t)) throw new Error("Invalid integer: " + t);
        if (u) return new f(BigInt(r ? "-" + t : t));
        for (var l = [], d = t.length, y = n, E = d - y; d > 0;) l.push(+t.slice(E, d)), (E -= y) < 0 && (E = 0), d -= y;
        return v(l), new c(l, r);
      }
      function J(t) {
        return "number" == typeof t ? function (t) {
          if (u) return new f(BigInt(t));
          if (h(t)) {
            if (t !== g(t)) throw new Error(t + " is not an integer.");
            return new p(t);
          }
          return $(t.toString());
        }(t) : "string" == typeof t ? $(t) : "bigint" == typeof t ? new f(t) : t;
      }
      c.prototype.toArray = function (t) {
        return Y(this, t);
      }, p.prototype.toArray = function (t) {
        return Y(this, t);
      }, f.prototype.toArray = function (t) {
        return Y(this, t);
      }, c.prototype.toString = function (t, e) {
        if (void 0 === t && (t = 10), 10 !== t) return z(this, t, e);
        for (var r, n = this.value, o = n.length, i = String(n[--o]); --o >= 0;) r = String(n[o]), i += "0000000".slice(r.length) + r;
        return (this.sign ? "-" : "") + i;
      }, p.prototype.toString = function (t, e) {
        return void 0 === t && (t = 10), 10 != t ? z(this, t, e) : String(this.value);
      }, f.prototype.toString = p.prototype.toString, f.prototype.toJSON = c.prototype.toJSON = p.prototype.toJSON = function () {
        return this.toString();
      }, c.prototype.valueOf = function () {
        return parseInt(this.toString(), 10);
      }, c.prototype.toJSNumber = c.prototype.valueOf, p.prototype.valueOf = function () {
        return this.value;
      }, p.prototype.toJSNumber = p.prototype.valueOf, f.prototype.valueOf = f.prototype.toJSNumber = function () {
        return parseInt(this.toString(), 10);
      };
      for (var Z = 0; Z < 1e3; Z++) s[Z] = J(Z), Z > 0 && (s[-Z] = J(-Z));
      return s.one = s[1], s.zero = s[0], s.minusOne = s[-1], s.max = q, s.min = K, s.gcd = V, s.lcm = function (t, e) {
        return t = J(t).abs(), e = J(e).abs(), t.divide(V(t, e)).multiply(e);
      }, s.isInstance = function (t) {
        return t instanceof c || t instanceof p || t instanceof f;
      }, s.randBetween = function (t, e) {
        var n = K(t = J(t), e = J(e)),
          o = q(t, e).subtract(n).add(1);
        if (o.isSmall) return n.add(Math.floor(Math.random() * o));
        for (var i = Y(o, r).value, a = [], u = !0, c = 0; c < i.length; c++) {
          var p = u ? i[c] : r,
            f = g(Math.random() * p);
          a.push(f), f < p && (u = !1);
        }
        return n.add(s.fromArray(a, r, !1));
      }, s.fromArray = function (t, e, r) {
        return j(t.map(J), J(e || 10), r);
      }, s;
    }();
    t.hasOwnProperty("exports") && (t.exports = e);
  }),
  BitcoinCashValidator = function (t) {
    function e() {
      return classCallCheck(this, e), possibleConstructorReturn(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, [SUPPORTED_CURRENCIES.bitcoin_cash]));
    }
    return inherits(e, BaseValidator), createClass(e, [{
      key: "validate",
      value: function value(t) {
        var e = !0;
        try {
          e = detectAddressFormat(t);
        } catch (t) {
          e = !1;
        }
        return e;
      }
    }]), e;
  }(),
  VERSION_BYTE = {
    testnet: [111, 196],
    prod: [0, 5, 28, 40]
  },
  PREFIXES$1 = ["bitcoincash", "bchtest", "regtest"];
function detectAddressFormat(t) {
  return decodeAddress(t);
}
function decodeAddress(t) {
  try {
    return decodeBase58Address(t);
  } catch (e) {
    return decodeCashAddress(t);
  }
}
function decodeBase58Address(t) {
  var e = base58Check.decode(t)[0];
  return VERSION_BYTE.testnet.concat(VERSION_BYTE.prod).some(function (t) {
    return t === e;
  });
}
function decodeCashAddress(t) {
  if (-1 !== t.indexOf(":")) return decodeCashAddressWithPrefix(t);
  for (var e = 0; e < PREFIXES$1.length; ++e) try {
    return decodeCashAddressWithPrefix(PREFIXES$1[e] + ": address");
  } catch (t) {}
  throw new Error();
}
var CHARSET_INVERSE_INDEX = {
    q: 0,
    p: 1,
    z: 2,
    r: 3,
    y: 4,
    9: 5,
    x: 6,
    8: 7,
    g: 8,
    f: 9,
    2: 10,
    t: 11,
    v: 12,
    d: 13,
    w: 14,
    0: 15,
    s: 16,
    3: 17,
    j: 18,
    n: 19,
    5: 20,
    4: 21,
    k: 22,
    h: 23,
    c: 24,
    e: 25,
    6: 26,
    m: 27,
    u: 28,
    a: 29,
    7: 30,
    l: 31
  },
  base32 = {
    decode: function decode(t) {
      validate("string" == typeof t, "Invalid base32-encoded string: " + t + ".");
      for (var e = new Uint8Array(t.length), r = 0; r < t.length; ++r) {
        var n = t[r];
        validate(n in CHARSET_INVERSE_INDEX, "Invalid value: " + n + "."), e[r] = CHARSET_INVERSE_INDEX[n];
      }
      return e;
    }
  };
function concat(t, e) {
  var r = new Uint8Array(t.length + e.length);
  return r.set(t), r.set(e, t.length), r;
}
function validChecksum(t, e) {
  return polymod$1(concat(concat(prefixToUint5Array(t), new Uint8Array(1)), e)).equals(0);
}
function polymod$1(t) {
  for (var e = [656907472481, 522768456162, 0xf33e5fb3c4, 748107326120, 130178868336], r = BigInteger(1), n = 0; n < t.length; ++n) {
    var o = t[n],
      i = r.shiftRight(35);
    r = r.and(34359738367).shiftLeft(5).xor(o);
    for (var a = 0; a < e.length; ++a) i.shiftRight(a).and(1).equals(1) && (r = r.xor(e[a]));
  }
  return r.xor(1);
}
function prefixToUint5Array(t) {
  for (var e = new Uint8Array(t.length), r = 0; r < t.length; ++r) e[r] = 31 & t[r].charCodeAt(0);
  return e;
}
var cashaddr = {
  decode: function decode(t) {
    validate("string" == typeof t && hasSingleCase(t), "Invalid address: " + t + ".");
    var e = t.toLowerCase().split(":");
    validate(2 === e.length, "Missing prefix: " + t + ".");
    var r = e[0],
      n = base32.decode(e[1]);
    validate(validChecksum(r, n), "Invalid checksum: " + t + ".");
    var o = fromUint5Array(n.slice(0, -8)),
      i = o[0],
      a = o.slice(1);
    return validate(getHashSize(i) === 8 * a.length, "Invalid hash size: " + t + "."), {
      prefix: r
    };
  }
};
function hasSingleCase(t) {
  return t === t.toLowerCase() || t === t.toUpperCase();
}
function fromUint5Array(t) {
  return convertBits(t, 5, 8, !0);
}
function convertBits(t, e, r, n) {
  for (var o = n ? Math.floor(t.length * e / r) : Math.ceil(t.length * e / r), i = (1 << r) - 1, a = new Uint8Array(o), u = 0, s = 0, c = 0, p = 0; p < t.length; ++p) {
    var f = t[p];
    for (validate(f >= 0 && f >> e == 0, "Invalid value: " + f + "."), s = s << e | f, c += e; c >= r;) c -= r, a[u] = s >> c & i, ++u;
  }
  return n ? validate(c < e && 0 == (s << r - c & i), "Input cannot be converted to " + r + " bits without padding, but strict mode was used.") : c > 0 && (a[u] = s << r - c & i, ++u), a;
}
function getHashSize(t) {
  switch (7 & t) {
    case 0:
      return 160;
    case 1:
      return 192;
    case 2:
      return 224;
    case 3:
      return 256;
    case 4:
      return 320;
    case 5:
      return 384;
    case 6:
      return 448;
    case 7:
      return 512;
  }
}
function decodeCashAddressWithPrefix(t) {
  var e = cashaddr.decode(t);
  return PREFIXES$1.some(function (t) {
    return t === e.prefix;
  });
}
function validate(t, e) {
  if (!t) throw new Error(e);
}
var EthereumValidator = function (t) {
    function e() {
      return classCallCheck(this, e), possibleConstructorReturn(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, [SUPPORTED_CURRENCIES.ethereum, SUPPORTED_CURRENCIES.omise_go, SUPPORTED_CURRENCIES.augur, SUPPORTED_CURRENCIES.eos, SUPPORTED_CURRENCIES.fuel, SUPPORTED_CURRENCIES.status, SUPPORTED_CURRENCIES.singularDTV, SUPPORTED_CURRENCIES.genesis_coin, SUPPORTED_CURRENCIES.walton_chain, SUPPORTED_CURRENCIES.ethereum_classic, SUPPORTED_CURRENCIES.ubiq]));
    }
    return inherits(e, BaseValidator), createClass(e, [{
      key: "validate",
      value: function value(t, e) {
        return isValidAddress$1(t);
      }
    }]), e;
  }(),
  isValidAddress$1 = function isValidAddress$1(t) {
    return !!/^(0x)?[0-9a-f]{40}$/i.test(t) && (!(!/^(0x)?[0-9a-f]{40}$/.test(t) && !/^(0x)?[0-9A-F]{40}$/.test(t)) || isChecksumAddress(t));
  },
  isChecksumAddress = function isChecksumAddress(t) {
    for (var e = t.replace("0x", ""), r = cryptoUtils.sha3(e.toLowerCase()), n = 0; n < 40; n++) if (parseInt(r[n], 16) > 7 && e[n].toUpperCase() !== e[n] || parseInt(r[n], 16) <= 7 && e[n].toLowerCase() !== e[n]) return !1;
    return !0;
  },
  RegExpValidator = function (t) {
    function e(t, r) {
      classCallCheck(this, e);
      var n = possibleConstructorReturn(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, t));
      return n.regExp = r, n;
    }
    return inherits(e, BaseValidator), createClass(e, [{
      key: "validate",
      value: function value(t, e) {
        return this.regExp.test(t);
      }
    }]), e;
  }(),
  MoneroValidator = function (t) {
    function e() {
      return classCallCheck(this, e), possibleConstructorReturn(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, [SUPPORTED_CURRENCIES.monero], /^4([0-9]|[A-B])([0-9a-zA-Z]){93}$|^4([0-9]|[A-B])([0-9a-zA-Z]){104}$/));
    }
    return inherits(e, RegExpValidator), e;
  }(),
  alphabet$1 = "rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz",
  base58ripple = baseXCheck(alphabet$1),
  RippleValidator = function (t) {
    function e() {
      return classCallCheck(this, e), possibleConstructorReturn(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, [SUPPORTED_CURRENCIES.ripple]));
    }
    return inherits(e, BaseValidator), createClass(e, [{
      key: "validate",
      value: function value(t, e) {
        try {
          var r = base58ripple.decode(t);
          return !!r && this.isValidVersion(r);
        } catch (t) {
          return !1;
        }
      }
    }, {
      key: "isValidVersion",
      value: function value(t) {
        return 0 === t.shift();
      }
    }]), e;
  }(),
  IotaValidator = function (t) {
    function e() {
      classCallCheck(this, e);
      var t = possibleConstructorReturn(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, [SUPPORTED_CURRENCIES.iota]));
      return t.addressLength = 81, t.regexTrytes = new RegExp("^[9A-Z]{" + t.addressLength + "}$"), t;
    }
    return inherits(e, BaseValidator), createClass(e, [{
      key: "validate",
      value: function value(t, e) {
        var r = this.removeChecksum(t);
        return this.regexTrytes.test(r);
      }
    }, {
      key: "removeChecksum",
      value: function value(t) {
        return t.slice(0, this.addressLength);
      }
    }]), e;
  }(),
  StellarValidator = function (t) {
    function e() {
      return classCallCheck(this, e), possibleConstructorReturn(this, (e.__proto__ || Object.getPrototypeOf(e)).call(this, [SUPPORTED_CURRENCIES.stellar]));
    }
    return inherits(e, BaseValidator), createClass(e, [{
      key: "validate",
      value: function value(t, e) {
        return isValid("ed25519PublicKey", t);
      }
    }]), e;
  }(),
  versionBytes = {
    ed25519PublicKey: 48,
    ed25519SecretSeed: 144,
    preAuthTx: 152,
    sha256Hash: 184
  };
function isValid(t, e) {
  if (e && 56 !== e.length) return !1;
  try {
    if (32 !== decodeCheck(t, e).length) return !1;
  } catch (t) {
    return !1;
  }
  return !0;
}
function decodeCheck(t, e) {
  var r = decode$2(e),
    n = r[0],
    o = r.slice(0, -2),
    i = o.slice(1),
    a = r.slice(-2);
  if (e !== encode$2(r)) throw new Error("invalid encoded string");
  var u = versionBytes[t];
  if (void 0 === u) throw new Error(t + ' is not a valid version byte name.  expected one of "accountId" or "seed"');
  if (n !== u) throw new Error("invalid version byte. expected " + u + ", got " + n);
  if (!verifyChecksum$1(calculateChecksum(o), a)) throw new Error("invalid checksum");
  return i;
}
function calculateChecksum(t) {
  return writeUInt16LE(crc16xmodem(t), 0);
}
function verifyChecksum$1(t, e) {
  if (t.length !== e.length) return !1;
  if (0 === t.length) return !0;
  for (var r = 0; r < t.length; r++) if (t[r] !== e[r]) return !1;
  return !0;
}
var crc16xmodem = function crc16xmodem(t, e) {
  for (var r = void 0 !== e ? ~~e : 0, n = 0; n < t.length; n++) {
    var o = r >>> 8 & 255;
    o ^= 255 & t[n], r = r << 8 & 65535, r ^= o ^= o >>> 4, r ^= o = o << 5 & 65535, r ^= o = o << 7 & 65535;
  }
  return r;
};
function writeUInt16LE(t, e) {
  var r = [];
  var n = converToByteArray(t = +t);
  return r.push(n[7]), r.push(t >>> 8), r;
}
function converToByteArray(t) {
  var e = [],
    r = 8;
  do {
    e[--r] = 255 & t, t >>= 8;
  } while (r);
  return e;
}
var charmap = function charmap(t, e) {
    return e || (e = {}), t.split("").forEach(function (t, r) {
      t in e || (e[t] = r);
    }), e;
  },
  rfc4648 = {
    alphabet: "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567",
    charmap: {
      0: 14,
      1: 8
    }
  };
function Decoder() {
  this.buf = [], this.shift = 8, this.carry = 0;
}
function decode$2(t) {
  return new Decoder().finalize(t);
}
function Encoder() {
  this.buf = "", this.shift = 3, this.carry = 0;
}
function encode$2(t) {
  return new Encoder().finalize(t);
}
rfc4648.charmap = charmap(rfc4648.alphabet, rfc4648.charmap), Decoder.prototype.charmap = rfc4648.charmap, Decoder.prototype.write = function (t) {
  var e = this.charmap,
    r = this.buf,
    n = this.shift,
    o = this.carry;
  return t.toUpperCase().split("").forEach(function (t) {
    if ("=" != t) {
      var i = 255 & e[t];
      (n -= 5) > 0 ? o |= i << n : n < 0 ? (r.push(o | i >> -n), o = i << (n += 8) & 255) : (r.push(o | i), n = 8, o = 0);
    }
  }), this.shift = n, this.carry = o, this;
}, Decoder.prototype.finalize = function (t) {
  return t && this.write(t), 8 !== this.shift && 0 !== this.carry && (this.buf.push(this.carry), this.shift = 8, this.carry = 0), this.buf;
}, Encoder.prototype.alphabet = rfc4648.alphabet, Encoder.prototype.write = function (t) {
  var e,
    r,
    n,
    o = this.shift,
    i = this.carry;
  for (n = 0; n < t.length; n++) e = i | (r = t[n]) >> o, this.buf += this.alphabet[31 & e], o > 5 && (e = r >> (o -= 5), this.buf += this.alphabet[31 & e]), i = r << (o = 5 - o), o = 8 - o;
  return this.shift = o, this.carry = i, this;
}, Encoder.prototype.finalize = function (t) {
  return t && this.write(t), 3 !== this.shift && (this.buf += this.alphabet[31 & this.carry], this.shift = 3, this.carry = 0), this.buf;
};
var supportedValidators = [new BitcoinCashValidator(), new EthereumValidator(), new MoneroValidator(), new RippleValidator(), new IotaValidator(), new StellarValidator(), new DefaultValidator()],
  supportedCurrencies = Object.values(SUPPORTED_CURRENCIES);
function validate$1(t, e) {
  if (-1 === supportedCurrencies.indexOf(e)) throw Error(e + " is not supported");
  return supportedValidators.find(function (t) {
    return t.isAppliedFor(e);
  }).validate(t, e);
}
export { validate$1 as validate, SUPPORTED_CURRENCIES };